<template>
  <div class="container mb-5">
    <div class="mt-5" v-if="!isReady"><AlertLoading /></div>
    <div v-else>
      <!-- Welcome -->
      <div class="row d-flex justify-content-center">
        <div class="h3 fw-bold">Welcome to the</div>
        <div class="game-title gt-2">House Competition</div>
        <p class="fw-bold fs-5">
          You are a member of<br /><span class="fw-bold fs-2">{{
            myGroup.name
          }}</span>
        </p>
      </div>

      <!-- Groups Preview -->
      <GroupsPreview :myGroupId="myGroup.id" />
      <div class="mb-5"></div>

      <!-- How It Works and User Card -->
      <div class="row d-flex justify-content-center text-start">
        <div class="col-sm-12 col-md-10 col-xl-7">
          <div class="gt-4 game-title">How It Works</div>
          <div class="border-game-rounded rounded-5 p-1 mb-4">
            <div class="bg-white rounded-5 p-4">
              <div class="fs-4 mb-1 fw-bold border-bottom border-2">
                <i class="bi bi-search text-primary"></i> Find Course
                Achievements
              </div>
              <p class="mb-4">
                Find the links throughout your Canvas course and answer
                questions related to the course material to earn the
                achievements.
              </p>

              <div class="fs-4 mb-1 fw-bold border-bottom border-2">
                <i class="bi bi-star-fill text-warning"></i> Earn Points
              </div>
              <p class="mb-4">
                Each achievement you earn adds to your personal points and your
                House's points and expands your collection of badges.
              </p>

              <div class="fs-4 mb-1 fw-bold border-bottom border-2">
                <i class="bi bi-person-arms-up text-success"></i> Work together
              </div>
              <p class="mb-1">
                Work with your fellow House members to earn the most points
                before the competition ends!
              </p>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mb-4">
          <RouterButton
            to="Home"
            label="Go to the House Competition"
            icon="arrow-right"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertLoading from "@/components/core/AlertLoading.vue";
import RouterButton from "@/components/activity/RouterButton.vue";

import { mapGetters, mapActions } from "vuex";
import DatastoreAPI from "@/helpers/DatastoreAPI";
import GroupsPreview from "@/components/activity/GroupsPreview.vue";

export default {
  name: "LandingView",
  components: {
    AlertLoading,
    RouterButton,
    GroupsPreview
  },
  mixins: [DatastoreAPI],
  data() {
    return {
      isReadyEntry: false,
      myGroupId: null
    };
  },
  computed: {
    ...mapGetters("datastore", ["getEntry"]),
    ...mapGetters(["mapToDatastore", "isAdmin", "getGroupId"]),
    ...mapGetters("groups", ["getMyGroup", "getGroups"]),
    isReady() {
      return this.isReadyEntry;
    },
    myGroup() {
      if (this.isAdmin) {
        return { id: "admin", name: "Admin" };
      }
      return (
        this.getGroups.find((group) => group.id === this.getGroupId) || {
          id: "",
          name: "Unknown"
        }
      );
    }
  },
  methods: {
    ...mapActions(["mapFromDatastore", "setGroupId"])
  },
  mounted() {
    if (this.getGroupId) {
      this.isReadyEntry = true;
      return;
    }

    console.log("Assigning group to user...");

    let lowestMemberCount = -1;
    let lowestGroupId = "group0";

    this.getGroups.forEach((group) => {
      let count = group.members.length;

      if (
        group.members.length < lowestMemberCount ||
        lowestMemberCount === -1
      ) {
        lowestMemberCount = count;
        lowestGroupId = group.id;
      }
    });

    if (this.isAdmin) {
      lowestGroupId = "admin";
    }

    this.setGroupId(lowestGroupId);
    this.updateEntry(this.mapToDatastore).then(() => {
      this.isReadyEntry = true;
      this.myGroupId = lowestGroupId;
    });
  }
};
</script>

<style scoped>
.game-title {
  margin-top: -25px;
}
</style>
